import { isObject } from '@principle-theorem/shared';
import {
  type IBaseTransactionCompleteCallbackData,
  type IHealthPointClaimRequestParams,
  type IHealthPointTransactionCompleteCallbackData,
  type IHealthPointTransactionErrorCallback,
  type IHealthPointTransactionSuccessBaseCallbackData,
  isHealthPointTransactionCompleteCallbackData,
  isHealthPointTransactionErrorCallback,
  isHealthPointTransactionSuccessBaseCallbackData,
} from '@principle-theorem/tyro';
import { type ITyroBaseExtendedData } from './tyro-base-extended-data';

export interface IHealthPointTransactionExtendedData
  extends ITyroBaseExtendedData {
  request: IHealthPointClaimRequestParams;
  response:
    | IBaseTransactionCompleteCallbackData
    | IHealthPointTransactionErrorCallback
    | IHealthPointTransactionSuccessBaseCallbackData
    | IHealthPointTransactionCompleteCallbackData;
}

export function isHealthPointTransactionExtendedData(
  data: unknown
): data is IHealthPointTransactionExtendedData {
  if (!isObject(data)) {
    return false;
  }
  return (
    // TODO: #3ax3vq Check request property?
    isHealthPointTransactionSuccessBaseCallbackData(data.response) ||
    isHealthPointTransactionCompleteCallbackData(data.response) ||
    isHealthPointTransactionErrorCallback(data.response)
  );
}
